const ISO8601dateFormat = 'yyyy-MM-dd';

export { ISO8601dateFormat };
